import { COMPONENT } from '@zola-helpers/client/dist/es/tracking/onboard/onboardTrackingConstants';
import type { EventConfig } from '@zola/tracking-contracts/src/configs';
import { CARD_TYPE_MAP, CardType } from '../constants/cardTypes';
import { CARD_TYPE_TO_BUSINESS_CATEGORY_MAP } from '../constants/tracking';

export const mapCardTypeToBusinessUnitComponent = (cardType: string): string => {
  switch (cardType) {
    case CARD_TYPE_MAP.dstd:
      return COMPONENT.DIGITAL_SAVE_THE_DATE;
    case CARD_TYPE_MAP.std:
      return COMPONENT.SAVE_THE_DATE;
    case CARD_TYPE_MAP.ctd:
      return COMPONENT.CHANGE_THE_DATE;
    case CARD_TYPE_MAP.thankyou:
      return COMPONENT.THANK_YOU_CARDS;
    case CARD_TYPE_MAP.menu:
    case CARD_TYPE_MAP.napkin:
    case CARD_TYPE_MAP.program:
    case CARD_TYPE_MAP.place:
    case CARD_TYPE_MAP.signage:
    case CARD_TYPE_MAP.sticker:
    case CARD_TYPE_MAP.tableNumber:
      return COMPONENT.DAY_OF_PAPER;
    case CARD_TYPE_MAP.holiday:
      return COMPONENT.HOLIDAY;
    case CARD_TYPE_MAP.weddingShower:
      return COMPONENT.WEDDING_SHOWER_INVITATION;
    default:
      return COMPONENT.INVITATIONS;
  }
};

export const mapCardTypeToBusinessCategory = (
  cardType: string,
  isDigital = false
): EventConfig['business_category'] => {
  if (isDigital && cardType === CARD_TYPE_MAP.std) return 'DIGITAL_SAVE_THE_DATE';
  return CARD_TYPE_TO_BUSINESS_CATEGORY_MAP[cardType as CardType] || 'UNATTRIBUTED';
};
